import React, { useState } from 'react';
import { WellbeingData } from '../../../types/wellbeing';
import { MoodIcon } from '../CategoryIcons';

interface MoodModalProps {
  data: WellbeingData;
  onSave: (data: Partial<WellbeingData>) => void;
  onClose: () => void;
}

export const MoodModal: React.FC<MoodModalProps> = ({ data, onSave, onClose }) => {
  const [localData, setLocalData] = useState({
    mood: data.mood ?? 0,
    stress: data.stress ?? 0,
    stressNote: data.stressNote ?? '',
    energy: data.energy ?? 0,
    sleepHours: data.sleepHours ?? 0,
    sleepQuality: data.sleepQuality ?? 0,
  });

  const Slider = ({
    label,
    value,
    onChange
  }: {
    label: string;
    value: number;
    onChange: (val: number) => void;
  }) => (
    <div style={{ marginBottom: '16px' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '6px',
      }}>
        <label style={{ fontSize: '13px', fontWeight: '600', color: '#0f172a' }}>
          {label}
        </label>
        <span style={{ fontSize: '13px', fontWeight: '600', color: '#6B7FFF' }}>
          {value}/5
        </span>
      </div>
      <input
        type="range"
        min="0"
        max="5"
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value))}
        style={{
          width: '100%',
          height: '6px',
          cursor: 'pointer',
          accentColor: '#6B7FFF',
        }}
      />
    </div>
  );

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '20px',
        paddingTop: '60px',
        overflowY: 'auto',
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: '20px',
          padding: '24px',
          maxWidth: '500px',
          width: '100%',
          maxHeight: 'calc(100vh - 120px)',
          overflowY: 'auto',
          position: 'relative',
          marginBottom: '40px',
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '20px',
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #f0f4ff 0%, #e0e7ff 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <MoodIcon />
          </div>

          <h2 style={{
            fontSize: '20px',
            fontWeight: '700',
            color: '#0f172a',
            margin: 0,
          }}>
            Samopoczucie
          </h2>
        </div>

        <Slider
          label="Samopoczucie ogólne"
          value={localData.mood}
          onChange={(v) => setLocalData({ ...localData, mood: v })}
        />

        <Slider
          label="Poziom stresu"
          value={localData.stress}
          onChange={(v) => setLocalData({ ...localData, stress: v })}
        />

        <div style={{ marginBottom: '16px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            color: '#0f172a',
            marginBottom: '6px',
          }}>
            Co Cię zestresowało? (opcjonalne)
          </label>
          <textarea
            value={localData.stressNote}
            onChange={(e) => setLocalData({ ...localData, stressNote: e.target.value })}
            placeholder="Opisz sytuację..."
            rows={2}
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '14px',
              borderRadius: '10px',
              border: '2px solid #e2e8f0',
              outline: 'none',
              resize: 'vertical',
              fontFamily: 'inherit',
            }}
          />
        </div>

        <Slider
          label="Energia/Zmęczenie"
          value={localData.energy}
          onChange={(v) => setLocalData({ ...localData, energy: v })}
        />

        <div style={{ marginBottom: '16px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            color: '#0f172a',
            marginBottom: '6px',
          }}>
            Ilość snu (godziny)
          </label>
          <input
            type="number"
            step="0.5"
            min="0"
            max="24"
            value={localData.sleepHours || ''}
            onChange={(e) => setLocalData({ ...localData, sleepHours: parseFloat(e.target.value) || 0 })}
            placeholder="7.5"
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '14px',
              borderRadius: '10px',
              border: '2px solid #e2e8f0',
              outline: 'none',
            }}
          />
        </div>

        <Slider
          label="Jakość snu"
          value={localData.sleepQuality}
          onChange={(v) => setLocalData({ ...localData, sleepQuality: v })}
        />

        <button
          onClick={() => onSave(localData)}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '10px',
            border: 'none',
            background: 'linear-gradient(135deg, #6B7FFF 0%, #5A6EE6 100%)',
            color: 'white',
            fontSize: '15px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Gotowe ✓
        </button>
      </div>
    </div>
  );
};
